import styled  from 'styled-components'
import { ReactComponent as ReactLogo}  from 'assets/Logo.svg';
import { fadeinout } from 'styles/animations';

export const StyledHome = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  box-sizing: border-box;
  align-items: center;
  max-height: 70vh;

  animation: ${fadeinout} 0.3s linear;
  -webkit-animation: ${fadeinout} 0.3s linear;
  -moz-animation: ${fadeinout} 0.3s linear;
  -o-animation: ${fadeinout} 0.3s linear;
  -ms-animation: ${fadeinout} 0.3s linear;

  pointer-events: none;

  @media only screen and (max-width: 1024px) {

  }
  @media only screen and (max-width: 420px) {

  }
  @media only screen and (max-height: 500px) {
    flex-direction: row;
    justify-content: center;
    width:90vw;
  }
`
export const StyledLogo = styled(ReactLogo)`
  padding-top: 10px;
  margin-bottom: 0;
  width: 40vw;
  height: 100%;
  @media only screen and (max-width: 1024px) {
    width:50vw;
  }
  @media only screen and (max-width: 420px) {
    width:90vw;
  }
  @media only screen and (max-height: 500px) {
    width:50vw;
  }
`;

export const Name = styled.p`
  margin: 0px;
  font-size: 50px;
  @media only screen and (max-width: 1024px) {
    font-size: 40px;
  }
  @media only screen and (max-width: 420px) {
    font-size: 40px;
  }
  @media only screen and (max-height: 500px) {
    font-size: 30px;
    padding-right: 30px;
  }
`;

export const Subtitle = styled.p`
  font-size: 30px;
  @media only screen and (max-width: 1024px) {
    font-size: 30px;
  }
  @media only screen and (max-width: 420px) {
    font-size: 30px;
  }
  @media only screen and (max-height: 500px) {
    font-size: 20px;
  }
`;
